<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">
                     
                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li class="active">
                                  <router-link :title="'تقرير الانشطة'" :to="{name: 'activities-confirm'}"> تقرير الانشطة</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div class="row"> 
                    <div class="col-lg-12 col-md-12 layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">

                                   <div class="row align-items-center">
                                    <div class="col-md-6">
                                        <h4>
                                            <i class="flaticon-computer-4"></i> 
                                        تقرير الانشطة
                                        </h4>
                                    </div> 
                                    <div class="col-md-6">
                                      <ul class="list-inline top-btns d-flex align-items-center m-0">
                                        <li class="list-inline-item">
                                          <button class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1
" v-if="searchingMode == 0" @click="searchingMode = 1"> <span>فلاتر البحث</span></button>
                                          <button class="btn btn-danger search-btn-wg mb-2 my-2 " v-if="searchingMode == 1" @click="searchingMode = 0">إغلاق X</button></li>
                                      </ul>
                                                                    
                                      </div>         
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                              
                                <form @submit.prevent="getIndexData(1)" v-if="searchingMode == 1" style="border: 1px solid #DDD;padding: 20px" class="mb-4">
                                    <div class="form-row">
                                        <div class="col-md-12 mt-2">
                                          <label for="">المرحلة الدراسية</label>
                                          <v-select v-model="stage" :options="stages" @search="onSearchStage" />
                                        </div>
                                        <div class="col-md-4 mt-2">
                            <button type="submit" name="time" class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1"> <span>بحث</span></button>

                                          <!-- <input type="submit" name="time" class=" btn btn-button-7 btn-block" value="بــــحــث"> -->
                                        </div>
                                    </div>
                                </form>
                                <div class="table-responsive">

                                  
                                  <div class="col-md-12">
                                      <button @click.prevent="printTable" v-if="data.form.length" class="btn btn-success mt-2 mb-2">
                                        <i class="fa fa-print"></i> طباعة
                                      </button>
                                    </div>
                                    <div class="col-md-12" id="print-table">
                                          
                                        <table class="table table-bordered mb-4">
                                            <thead>
                                                <tr>
                                                    <th>
                                                      الرقم المرجعى للبرنامج
                                                    </th>
                                                    <th >التاريخ</th>
                                                    <th >الوصف</th>
                                                    <th >المكان</th>
                                                    <th >الفترة</th>
                                                    <th >المسئول</th>
                                                    <th >عدد الحضور </th>
                                                    <th >نسبة الحضور </th>
                                                    <th > إجمالى الاشتراكات حسب الميزانية</th>
                                                    <th >إجمالى الاشتراكات الفعلى</th>
                                                    <th >التكلفة التقديرية</th>
                                                    <th >التكلفة الفعلية</th>
                                                    <th >العجز المتوقع حسب الميزانية</th>
                                                    <th >العجز المتوقع الفعلى</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in data.form" :key="index">
                                                    <td>{{item.id}}</td>
                                                    <td>{{item.program_date}}</td>
                                                    <td>{{item.description}}</td>
                                                    <td>{{item.place}}</td>
                                                    <td>{{item.period}}</td>
                                                    <td>{{item.teacher}}</td>
                                                    <td>{{item.attend_no}}</td>
                                                    <td>{{item.attend_per}}%</td>
                                                    <td>{{item.budget_total_fees}}</td>
                                                    <td>{{item.total_fees}}</td>
                                                    <td>{{item.budget_total_cost}}</td>
                                                    <td>{{item.total_cost}}</td>
                                                    <td>{{item.budget_expect_cost}}</td>
                                                    <td>{{item.expect_cost}}</td>
                                                    
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th>
                                                      الرقم المرجعى للبرنامج
                                                    </th>
                                                    <th >التاريخ</th>
                                                    <th >الوصف</th>
                                                    <th >المكان</th>
                                                    <th >الفترة</th>
                                                    <th >المسئول</th>
                                                    <th >عدد الحضور </th>
                                                    <th >نسبة الحضور </th>
                                                    <th > إجمالى الاشتراكات حسب الميزانية</th>
                                                    <th >إجمالى الاشتراكات الفعلى</th>
                                                    <th >التكلفة التقديرية</th>
                                                    <th >التكلفة الفعلية</th>
                                                    <th >العجز المتوقع حسب الميزانية</th>
                                                    <th >العجز المتوقع الفعلى</th>
                                                </tr>
                                                <tr v-if="data.form.length">
                                                  <th colspan="8">
                                                    إجمالى
                                                  </th>
                                                  <th>{{totals.budget_total_fees}}</th>
                                                  <th>{{totals.total_fees}}</th>
                                                  <th>{{totals.budget_total_cost}}</th>
                                                  <th>{{totals.expect_cost}}</th>
                                                  <th>{{totals.budget_expect_cost}}</th>
                                                  <th>{{totals.expect_cost}}</th>
                                                </tr>
                                            </tfoot>
                                            
                                        </table>
                                    </div>

                                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


</template>
<script>
import 'vue-select/dist/vue-select.css';
import VueDatetimeJs from 'vue-datetime-js'

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  components: {
    Treeselect,
    datePicker: VueDatetimeJs,
  },
  data() {
    return {
      teachers: [],
      totals: {
        'total_fees': 0,
        'budget_total_fees': 0,
        'total_cost': 0,
        'budget_total_cost': 0,
        'expect_cost': 0,
        'budget_expect_cost': 0,
      },
      printData: {
      },
      form: {},
      data: {
        errors: {},
        form: [],
        data: {},
        searching:{
            stage_id: '',
        },
        paginated: {},
        showFilter: false,
      },
       options: [],
       stages: [],
       groups: [],
       searchingMode: 0,
       stage: {},
       group: {},
    };
  },
  created(){
        this.flashAlert();
        this.search(null, '', this, 'stage');
  },
  methods: {
    clcTotal(){
      for (let index = 0; index < this.data.form.length; index++) {
      
          this.totals.total_fees = (Number(this.totals.total_fees) + Number(this.data.form[index].total_fees));
          this.totals.budget_total_fees = (Number(this.totals.budget_total_fees) + Number(this.data.form[index].budget_total_fees));
          this.totals.total_cost = (Number(this.totals.total_cost) + Number(this.data.form[index].total_cost));
          this.totals.budget_total_cost = (Number(this.totals.budget_total_cost) + Number(this.data.form[index].budget_total_cost));
          this.totals.expect_cost = (Number(this.totals.expect_cost) + Number(this.data.form[index].expect_cost));
          this.totals.budget_expect_cost = (Number(this.totals.budget_expect_cost) + Number(this.data.form[index].budget_expect_cost));
      
        
      }
    },
    resortData(){
        this.data.searching.sorting = this.data.searching.sorting == 'asc' ? 'desc' : 'asc';
        this.getIndexData(1);
    },
    printTable(){
      setTimeout(() => {
        this.print_element('print-table', 'تقرير الانشطة');
      }, 1000);
    },
    print(data){
      this.printData = data;
        this.$baseApi.get('/budgets/' + data.id).then((response)=>{
            if(response.data.code == 200){
              this.printData = response.data.data.budget;
              setTimeout(() => {
              this.$htmlToPaper('printMe');
                
              }, 2000);

            }else{
                alert(response.data.error.error);
            }
        });
    },
    onSearchStage(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'stage');
      }
    },
    search(loading, w, vm, type){
      this.$baseApi.get('/budgets?pluck=1&search='+w+'&pluckType='+type).then((response)=>{
          if(loading){
            loading(false);
          }
            if(response.data.code == 200){
              if(type == 'stage'){
                this.stages = response.data.data.options;
              }
            }else{
                alert(response.data.error.error);
            }
        });
    },
    confirmData(){
      this.$baseApi.post('/activities-confirm', this.data.form).then((response)=>{
            if(response.data.code == 200){
              this.getIndexData(1);

            }else{
                alert(response.data.error.error);
            }
        }).catch((error) => {
            this.data.errors = JSON.parse(JSON.stringify(error.response.data.errors));
          });
    },
      getIndexData(page){
        this.data.form = [];
        this.$baseApi.get('/activities-confirm?page=' + page, {
                    params: this.data.searching
                }).then((response)=>{
            if(response.data.code == 200){
               this.data.form = response.data.data.activities;
               this.clcTotal();

            }else{
                alert(response.data.error.error);
            }
        });
      },
      deleteData(data){
          this.data.data.splice(this.data.data.indexOf(data), 1);
      },
    clearFilter(items) {
      this.data.showFilter = !this.data.showFilter
      if (!this.data.showFilter) {
        for (const itemsKey in items) {
          this.data.searching[itemsKey] = ''
        }
        this.getIndexData(1);
      }
    }
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    },
    getErrors() {
      return JSON.parse(JSON.stringify(this.data.errors))
    }
  },
   watch: {
    // Note: only simple paths. Expressions are not supported.
    stage(newValue) {
      this.data.searching.stage_id = newValue.id;
    }
  }
};
</script>
<style>
</style>
